import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)

import {
  withDefaults
} from 'vue'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import ButtonSecondary from '@/views/components/button/ButtonSecondary.vue'

interface IPropsButtonFileUpload {
  extensions: string[] | string | RegExp,
  size: number,
  accept: string,
  inputId: string,
  buttonText: string
  buttonClassList: string
  isDisabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonSecondaryUpload',
  props: {
    extensions: { default: 'jpg,jpeg,png' },
    size: { default: 0 },
    accept: { default: 'image/png,image/jpeg,image/jpg' },
    inputId: { default: '' },
    buttonText: { default: '' },
    buttonClassList: { default: 'btn-size-md' },
    isDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { extensions: string[] | string | RegExp, size: number, accept: string, inputId: string, buttonText: string, buttonClassList: string, isDisabled: boolean }




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ButtonFileUpload, null, {
      default: _withCtx(() => [
        _createVNode(ButtonSecondary, {
          classList: __props.buttonClassList,
          buttonText: __props.buttonText,
          disabled: __props.isDisabled
        }, {
          icon: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["classList", "buttonText", "disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})